var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.partnerSettings.googleRecaptchaKey,"data-callback":_vm.onVerify,"data-expired-callback":_vm.onExpired,"data-error-callback":_vm.onError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }